export const SEARCH_TYPES = {
	card: "InformationSearchFilterDTO",
	template: "TemplateSearchFilterDTO",
};
